import React, { Fragment, useMemo } from 'react';

//* Components
import { Text } from '@weareconceptstudio/core';

//* Style
import BreadcrumbStyle from './style';

const Breadcrumb = ({ breadcrumbs, isMenuMobileVersion, name }) => {
	const breads = useMemo(() => {
		return breadcrumbs?.map((bread, index) => (
			<Fragment key={index}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					viewBox='0 0 4 4'
					fill='none'>
					<mask
						id='mask0_876_2562'
						maskUnits='userSpaceOnUse'
						x='0'
						y='0'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M1.99785 0.500001C2.39342 0.499576 2.78023 0.616464 3.10937 0.835883C3.43851 1.0553 3.6952 1.3674 3.84697 1.7327C3.99873 2.098 4.03874 2.5001 3.96197 2.88815C3.8852 3.2762 3.69509 3.63277 3.41566 3.91277C3.13624 4.19277 2.78005 4.38362 2.39216 4.46118C2.00427 4.53875 1.6021 4.49954 1.23649 4.34853C0.870876 4.19752 0.558258 3.94148 0.338165 3.61279C0.118072 3.2841 0.000387446 2.89753 9.56015e-07 2.50196C-0.000517268 1.97156 0.209668 1.46267 0.584332 1.08724C0.958997 0.711807 1.46745 0.500571 1.99785 0.500001Z'
							fill='var(--catalog_mainColor)'
						/>
					</mask>
					<g mask='url(#mask0_876_2562)'>
						<path
							d='M0.124249 0.189091L-0.311523 4.37524L3.87463 4.81102L4.3104 0.624863L0.124249 0.189091Z'
							fill='url(#paint0_linear_876_2562)'
						/>
					</g>
					<defs>
						<linearGradient
							id='paint0_linear_876_2562'
							x1='0.643657'
							y1='3.77648'
							x2='3.51682'
							y2='1.13466'
							gradientUnits='userSpaceOnUse'>
							<stop stopColor='var(--catalog_logoColor1)' />
							<stop
								offset='1'
								stopColor='var(--catalog_logoColor2)'
							/>
						</linearGradient>
					</defs>
				</svg>

				<Text
					className='catalog-p catalog-p5 breadcrumb-item'
					text={bread.name}
				/>
			</Fragment>
		));
	}, [breadcrumbs]);

	return (
		<BreadcrumbStyle className={'breadcrumb-block'}>
			<div className={`breadcrumb-inner-block ${isMenuMobileVersion ? '' : 'additional-block'}`}>
				<Text
					className='catalog-p catalog-p5'
					text={name}
				/>
				{breads}
			</div>
		</BreadcrumbStyle>
	);
};

export default Breadcrumb;
